(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-page"]) return;
  try {
    
  // Function to handle the tab change logic
  function handleTabChange() {
    const xTabs = document.querySelector('x-tabs');
    const selectedIndex = parseInt(xTabs.getAttribute('selected-index'));

    const pressFeatures = document.querySelector('.press-features');
    const spottedOn = document.querySelector('.spotted-on');

    if (selectedIndex === 0) {
        pressFeatures.style.display = 'none';
        spottedOn.style.display = 'block';
    } else if (selectedIndex === 1) {
        pressFeatures.style.display = 'block';
        spottedOn.style.display = 'none';
    }
  }
  
  // Create a MutationObserver to watch for changes in the selected-index attribute
  const xTabs = document.querySelector('x-tabs');
  const observer = new MutationObserver(handleTabChange);
  
  observer.observe(xTabs, { attributes: true, attributeFilter: ['selected-index'] });


  } catch(e) { console.error(e); }
})();
})();
